import "./TimerImage.scss";

export default function TimerImage() {
  return (
    <div className='elements__timerImage'>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
